export default {
  namespaced: true,
  state: () => ({
    onPointDumpsterLocationStaticMapUri: '',
    jsonScript: {},
    savedLocationResponse: {}
  }),
  actions: {},
  getters: {},
  mutations: {
    onPointDumpsterLocationStaticMapUri (state, val) {
      state.onPointDumpsterLocationStaticMapUri = val
    },
    jsonScript (state, val) {
      state.jsonScript = val
    },
    savedLocationResponse (state, val) {
      state.savedLocationResponse = val
    },
    onPoint (state, val) {
      state = val
    }
  }
}
